import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { DealerChangeLogEntity } from "src/app/features/DealerChangeLog/types/DealerChangeLogEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { DatePickerInput } from "../../../../../components/Form/formComponents/DatePicker/DatePicker";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { dealerChangeLogStatusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const DealerChangeLogSearchForm: FC<SearchFormProps<DealerChangeLogEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <TextInput name="id" />
            </Form.Item>
            <Form.Item label={t("form.dealerName")} name="dealerName">
                <TextInput name="dealerName" />
            </Form.Item>
            <Form.Item label={t("form.siteName")} name="siteName">
                <TextInput name="siteName" />
            </Form.Item>
            <Form.Item label={t("form.siteId")} name="siteId">
                <TextInput name="siteId" />
            </Form.Item>
            <Form.Item label={t("form.createdFrom")} name="createdFrom">
                <DatePickerInput name="createdFrom" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.createdTo")} name="createdTo">
                <DatePickerInput name="createdTo" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={dealerChangeLogStatusSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
